import {LanguagesEnum} from '../../locale/types'
import {LTRStickyStyles, RTLStickyStyles} from './constants'
import {TimeSlotStickyStylesMap} from './types'

export const getTimeSlotStickyStylesMap = (lang: LanguagesEnum): TimeSlotStickyStylesMap =>
  lang === LanguagesEnum.HEB ? RTLStickyStyles : LTRStickyStyles
